/* eslint-disable no-unused-vars */
import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Match from './match';
import ThirdPlacePlayoff from './thirdplaceplayoff';
import Final from './final';
import ProgressionLines from './progressionlines';
import { Bracketstyles } from './bracletstyles';
import dataSlice from '../../state/slices/data';

const STAGE_SEQUENCE = [
  'round32',
  'round16',
  'quarterfinals',
  'semifinals',
  'final',
];

function isLikelyAppWebView() {
  const { userAgent } = navigator;
  const isAndroidWebView =
    /\bwv\b/i.test(userAgent) || /Version\/4\.0/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isIOSBrowser = /Safari|CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent);

  return isAndroidWebView || (isIOS && !isIOSBrowser);
}

function shouldEnableSwipeNavigation() {
  if (typeof window === 'undefined' || isLikelyAppWebView()) {
    return false;
  }

  return window.matchMedia('(pointer: coarse)').matches;
}

export default function Bracket() {
  const dispatch = useDispatch();
  const matches = useSelector((state) => state.data.matches);
  const activeButton = useSelector((state) => state.data.activeButton);
  const touchStartRef = useRef(null);
  const swipeEnabled = shouldEnableSwipeNavigation();

  const setStageFromSwipe = (direction) => {
    const currentIndex = STAGE_SEQUENCE.indexOf(activeButton);
    if (currentIndex === -1) return;

    const nextIndex = currentIndex + direction;
    const nextStage = STAGE_SEQUENCE[nextIndex];

    if (nextStage) {
      dispatch(dataSlice.actions.setActiveButton(nextStage));
    }
  };

  const handleTouchStart = (event) => {
    touchStartRef.current = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    };
  };

  const handleTouchEnd = (event) => {
    if (!touchStartRef.current) return;

    const deltaX = event.changedTouches[0].clientX - touchStartRef.current.x;
    const deltaY = event.changedTouches[0].clientY - touchStartRef.current.y;
    touchStartRef.current = null;

    if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }

    if (deltaX < 0) {
      setStageFromSwipe(1);
      return;
    }

    setStageFromSwipe(-1);
  };

  const bracketWrapProps = {};

  if (swipeEnabled) {
    bracketWrapProps.onTouchStart = handleTouchStart;
    bracketWrapProps.onTouchEnd = handleTouchEnd;
  }

  const bracketHeightStyles = {
    height:
      activeButton === 'round32'
        ? 2300
        : activeButton === 'round16'
          ? 1200
          : 800,
  };

  return (
    <Bracketstyles>
      <div
        className="bracket-wrap"
        {...bracketWrapProps}
        style={bracketHeightStyles}
      >
        <ProgressionLines />
        {matches.map((match) => {
          console.log('Rendering match:', match);
          if (match.stage === 'Play-off for third place') {
            return <ThirdPlacePlayoff key={match.id} {...match} />;
          }
          if (match.stage === 'Final') {
            return <Final key={match.id} {...match} />;
          }
          return <Match key={match.id} {...match} />;
        })}
      </div>
    </Bracketstyles>
  );
}
